import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Campaign } from "../../../@core/data/campaign";
import codes from "../../../../assets/data/country_code.json";
import { CampaignService } from "../../../@core/utils/campaign.service";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";


@Component({
  selector: "ngx-projects-campaign-new",
  templateUrl: "./projects-campaign-new.component.html",
  styleUrls: ["./projects-campaign-new.component.scss"],
})
export class ProjectsCampaignNewComponent implements OnInit {
  campaign: Campaign = {
    id: "",
    affiliate_id: "",
    offer_id: "",
    checkDoubles: false,
    dayOfTheWeek: [true, true, true, true, true, true, true],
  };
  countryCodes: any[] = [];
  offerIds: any = [];
  loading: boolean = false;
  multioffer: boolean = false;
  id: string;
  timeOffset:number = 0;
  hours: number[] = Array.from({ length: 25 }, (_, i) => i);

  dayNames = [
    "Domenica",
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignProjectService: CampaignProjectService,
    private campaignService: CampaignService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];
    this.countryCodes = <any>codes;
    const date1 = new Date();
    this.timeOffset = date1.getTimezoneOffset()/60;

    if (id) {
      this.loading = true;
      this.id = id;
      this.campaign = <Campaign>await this.campaignProjectService.getCampaign(id);
      this.campaign.dayOfTheWeek = this.campaign.dayOfTheWeek || [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ];
      this.campaign.country = this.campaign.country || "IT";

      if (
        typeof this.campaign.offer_id === "string" ||
        this.campaign.offer_id instanceof String
      ) {
        this.multioffer = false;
        this.offerIds.push({ form: "", offer: "" })
      } else {
        this.multioffer = true;

        Object.keys(this.campaign.offer_id).map((form) => {
          this.offerIds.push({ form, offer: this.campaign.offer_id[form] });
        });
      }
    }
    
    // this.campaign.dailyMax = this.campaignService.normalizeDailyMax(this.campaign.dailyMax);

    this.loading = false;
  }

  addIP() {
    if (this.campaign.excludedIP) {
      this.campaign.excludedIP.push("");
    } else {
      this.campaign.excludedIP = [""];
    }
  }

  editIp(e, i) {
    this.campaign.excludedIP[i] = e.target.value;
    console.log(this.campaign.excludedIP);
  }

  removeIP(i) {
    console.log(i);

    console.log(this.campaign.excludedIP);
    this.campaign.excludedIP.splice(i, 1);
  }

  switchMultioffer() {
    this.multioffer = !this.multioffer;
    if (this.multioffer == false) {
      this.campaign.offer_id = "";
    }
    console.log(this.campaign)
  }

  addOffer() {
    this.offerIds.push({ form: "", offer: "" });
  }

  editOffer(e, i, type) {
    this.offerIds[i][type] = e.target.value;
    this.syncOffers();
  }

  removeOffer(i) {
    this.offerIds.splice(i, 1);
    this.syncOffers();
  }

  syncOffers() {
    this.campaign.offer_id = {};
    this.offerIds.map((o) => {
      this.campaign.offer_id[o.form] = o.offer;
    });

    console.log(this.campaign);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  
  updateDailyMax(value: number) {
    this.campaign.dailyMax = value;
  }
  
  // updateMinHour(value: number, index: number) {
  //   this.campaign.dailyMax.days[index].timestart = value;
  // }
  
  // updateMaxHour(value: number, index: number) {
  //   this.campaign.dailyMax.days[index].timeend = value;
  // }

  async save() {
    if (this.id) {
      try {
         const result = await this.campaignProjectService.editCampaign(this.campaign, this.id);
        // this.router.navigate(["home", "projects-campaigns"]);
        if (result) {location.reload();}
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>(
          await this.campaignProjectService.createCampaign(this.campaign)
        );
        this.id = data.id;
        this.router.navigate(["home", "projects-campaigns"]);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
